import React, { useEffect } from 'react'
import { useSelector, connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import Button, { TYPES as BUTTON_TYPES } from '../../Button/index'
import { selectStaticTextByKey } from '../../../services/static-text/selectors'
import IconV2, { ICON_TYPES } from '../../Icon.v2/index'
import { URL_ACCOUNT_PAUSE, URL_ACCOUNT_CANCEL_CONFIRM } from '../../../services/url/constants'
import { scrollToTop } from '../../../services/dom/index'
import { selectUserRequestCountry, getUserLanguagePrimary } from '../../../services/user/index'
import { historyRedirect } from '../../../services/navigation/index'
import { DE as COUNTRY_DE } from '../../../services/country/index'
import { getBoundActions } from '../../../actions/index'
import { connect as connectStaticText } from '../../StaticText/connect'
import { executeUserAccountCancel } from '../../../services/user-account/index'
import { PAUSED_OFFER_SHOWN_GA4_EVENT } from '../../../services/event-tracking/index'

/**
 * Cancel modal for the price increase
 * @returns {JSX.Element} Cancel modal
 */
function MyAccountCancelModal (props) {
  const {
    url,
    user,
    setEventDefault,
    setUserAccountCancel,
  } = props
  const staticText = useSelector(selectStaticTextByKey('myAccountCancelModal'))

  useEffect(() => {
    setEventDefault(PAUSED_OFFER_SHOWN_GA4_EVENT)
  }, [])

  const userRequestCountry = useSelector(selectUserRequestCountry)
  const isGermanUser = userRequestCountry === COUNTRY_DE
  const userLanguage = getUserLanguagePrimary(user)

  const title = staticText.get('defaultTitle')
  const subtitle = staticText.get('defaultSubtitle')

  const onContinueCancelFlowClick = () => {
    if (url === URL_ACCOUNT_CANCEL_CONFIRM) {
      setUserAccountCancel()
    }
    scrollToTop()
  }

  const renderGermanContent = () => {
    return (
      <div className="my-account-cancel-modal__buttons my-account-cancel-modal__buttons--de">
        <div className="my-account-cancel-modal__keep-button-wrapper">
          <Button
            url={URL_ACCOUNT_PAUSE}
            onClick={scrollToTop}
            type={BUTTON_TYPES.PRIMARY}
            className="my-account-cancel-modal__keep-button"
          >
            {staticText.get('pauseButton')}
          </Button>
        </div>
        <Button
          url={url}
          onClick={onContinueCancelFlowClick}
          type={BUTTON_TYPES.SECONDARY}
          className="my-account-cancel-modal__feedback-button"
        >
          {staticText.get('helpGaiaGetBetter')}
        </Button>
        <Button
          onClick={() => executeUserAccountCancel({
            props,
            historyRedirect,
            userLanguage,
            cancelConfirmUrl: URL_ACCOUNT_CANCEL_CONFIRM,
          })}
          type={BUTTON_TYPES.SECONDARY}
          className="my-account-cancel-modal__cancel-now-button"
        >
          {staticText.get('cancelNow')}
        </Button>
      </div>
    )
  }

  return (
    <div className="my-account-cancel-modal">
      <div className="my-account-cancel-modal__title">{title}</div>
      <div className="my-account-cancel-modal__subtitle">{subtitle}</div>
      <div className="my-account-cancel-modal__line"></div>
      {isGermanUser
        ? renderGermanContent()
        : (
          <div className="my-account-cancel-modal__buttons">
            <Button
              url={URL_ACCOUNT_PAUSE}
              onClick={scrollToTop}
              type={BUTTON_TYPES.PRIMARY}
              className="my-account-cancel-modal__keep-button"
            >
              {staticText.get('pauseButton')}
            </Button>
            <Button
              url={url}
              onClick={onContinueCancelFlowClick}
              type={BUTTON_TYPES.SECONDARY}
              className="my-account-cancel-modal__cancel-button"
            >
              <div>
                {staticText.get('cancelButton')}
                <IconV2
                  className="my-account-cancel-modal__cancel-button-icon"
                  type={ICON_TYPES.CHEVRON_RIGHT}
                />
              </div>
            </Button>
          </div>
        )
      }
    </div>
  )
}

export default compose(
  connectStaticText({ storeKey: 'accountCancelDissatisfied' }),
  connectRedux(
    (state) => ({
      userAccount: state.userAccount,
      auth: state.auth,
      user: state.user,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setUserAccountCancelReason: actions.userAccount.setUserAccountCancelReason,
        setUserAccountCancelFormData: actions.userAccount.setUserAccountCancelFormData,
        setUserAccountCancel: actions.userAccount.setUserAccountCancel,
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
)(MyAccountCancelModal)
